<!-- 
<div class="flex flex-col justify-center items-center w-full  transition-all duration-300 ">


    <div class="flex justify-between items-center w-full">


        <div tabindex="0" (keydown)="keyDwn($event,data!.route)"  (click)="onNodeSelect($event, data)" 
            class="flex nested-elem  {{expanded && !mobile ? ' border-primary-50/50 rounded-none bg-none nested-elem-nobg' : 'mr-2  rounded-xl'}}  nested-elem-focus  grow  text-sm cursor-pointer {{data!.cssClass}}" >
            <div class="flex gap-2 items-center  {{expanded && !mobile ? 'icon-text-collapse' : 'icon-text-expand'}}">
    
                <div @fadeInOutWithBlur class="flex items-center justify-center {{expanded && !mobile ? 'icon-collapse' : 'icon-expand'}}">
                    <div *ngIf="data?.icon != undefined" class="w-full {{data?.icon}}"></div>
                    <div *ngIf="data?.icon == undefined && parentIcon != undefined" class="w-full {{parentIcon}} "></div>
                    <div *ngIf="data?.icon == undefined && parentIcon == undefined" class="w-full icon-placeholder "></div>
                </div>
    
                <div class="text-left select-none {{expanded && !mobile ? 'text-collapse' : 'text-expand'}}">
                    <p [title]="data?.name" class="select-none"> {{ data!.name.length > 18 ? (data!.name.slice(0, 18) + '...') : data!.name }}</p>
                </div>
            </div>
    
            <div tabindex="0" (keydown)="expandOnFocus($event,data!.name); $event.stopPropagation()" (click)="expandNode(data!.name);  $event.stopPropagation()"
                *ngIf="data!.children.length >0 && !expanded" style="width: 5%;"
                class="w-3/12 flex items-center justify-end cursor-pointer chevron-focus">
                <div class="w-5 h-5 circular-focus">
    
    
                    <div class="w-5 h-5 {{data?.iconClass ?? 'icon-chevron-down'}} ">
                        
                    </div>
    
                </div>
            </div>
    
    
        </div>
    
        <div *ngIf="!expanded || mobile" class="button-expand">
    
            <button nodisable="true" tabindex="-1" id="openNew" class="new-button rounded-lg p-2 "
                (click)="newWindow(data!.route)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-4 h-4">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
            </button>
    
        </div>
    </div>
    
    
        <div @fadeInOutWithBlur class="w-full h-full relative rounded-lg {{data!.expand && data!.children.length > 0 && !expanded ? 'showChildren' : 'hideChildren'}}" >
    
            @for(children of data!.children; track $index){
    
                <div class="pl-4 mt-2">
                    <app-node [data]="children" [expand]="data!.expand" [parentIcon]="data?.icon || parentIcon" [mobile]="mobile"
                        (onNodeClick)="onNodeSelect($event, undefined)"></app-node>
        
                </div>
            }
        </div>
    
</div> -->
<div class="flex flex-wrap justify-between items-center align-middle">
    <div tabindex="0" (keydown)="keyDwn($event,data!.route)"
        class="flex  nested-elem nested-elem-focus mr-2 rounded-xl grow items-center font-bold text-sm {{data!.cssClass}}">

        <div class="flex items-center cursor-pointer w-1/12" (click)="onNodeSelect(data!.route)">
            <div *ngIf="data?.icon != undefined" class="{{expanded && !mobile ? 'w-10 h-10' : 'h-5 w-5'}} {{data?.icon}}"></div>
            <div *ngIf="data?.icon == undefined && parentIcon != undefined" class="{{expanded && !mobile ? 'w-10 h-10' : 'h-5 w-5'}} {{parentIcon}} "></div>
            <div *ngIf="data?.icon == undefined && parentIcon == undefined" class="{{expanded && !mobile ? 'w-10 h-10' : 'h-5 w-5'}} icon-placeholder "></div>
        </div>


        <div class="w-8/12 text-left cursor-pointer select-none pl-2" (click)="onNodeSelect(data!.route)"
            [title]="data?.name" *ngIf="data!.children.length >0 && !expanded">
            <p class="select-none break-before-all">{{data!.name}}</p>
        </div>


        <div class="w-11/12 text-left cursor-pointer select-none pl-2" (click)="onNodeSelect(data!.route)"
            [title]="data?.name" *ngIf="data!.children.length ==0 && !expanded">
            <p class="select-none break-words break-inside-avoid-column break-before-column">{{data!.name}}</p>
        </div>


        <div tabindex="0" (keydown)="expandOnFocus($event,data!.name)" (click)="expandNode(data!.name)"
            *ngIf="data!.children.length >0 && !expanded" class="w-3/12 flex items-center justify-end cursor-pointer chevron-focus">
            <div class="w-5 h-5 circular-focus">


                <div class="w-5 h-5 {{data?.iconClass}} ">

                </div>

            </div>
        </div>

    </div>


    <button matTooltip="Apri in una nuova scheda"  nodisable="true" tabindex="-1" id="openNew" ejs-button
        class="new-button rounded-lg p-2 " (click)="newWindow(data!.route)" *ngIf="!expanded">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
        </svg>
    </button>


    <div class="w-full  rounded-lg" *ngIf="data && data.expand &&  data.children.length > 0 && !expanded">

        @for(children of data.children; track $index){

        <div @fadeInOutWithBlur class="pl-4 mt-1">
            <app-node [data]="children" [expand]="data.expand" [parentIcon]="data.icon" [mobile]="mobile"
                (onNodeClick)="onNodeSelect($event)"></app-node>
        </div>
        }

    </div>
</div>